import { axios } from "@/lib/axios";

import { IAPIGetEmailLogs } from "../../types";

export const getEmailLogsByEmail = (
  email: string,
  { page, limit }: { page?: number; limit?: number } = {}
): Promise<IAPIGetEmailLogs> => {
  return axios.get(`/notif-s/bo/api/v1/email-logs`, {
    params: { email, page, limit },
  });
};
